import {
    BarcodeOutlined,
    CalendarOutlined,
    CloudUploadOutlined,
    ContainerOutlined,
    DollarOutlined,
    ExperimentOutlined,
    FileDoneOutlined,
    FileTextOutlined,
    ShoppingCartOutlined,
    UserOutlined
} from "@ant-design/icons";
import {Menu} from "antd";
import {NavLink} from "react-router-dom";
import {RoutingPaths} from "../../routing/routingContainer";
import beeftekaLogo from '../../../svg/beefteka_logo_white.svg';
import browarkoloLogo from '../../../svg/browar_kolo_logo.svg';
import styles from "./siderMenu.module.scss";
import {useCurrentRoutingPath} from "digimuth-components/dist";
import useCurrentUserRoles from "../../../hooks/useCurrentUserRoles";
import {ApplicationUserRole} from "../../../api";
import React from "react";

export default function SiderMenu() {
    const route = useCurrentRoutingPath(RoutingPaths)?.route || "";
    const roles = useCurrentUserRoles();

    const menuItems = [
        {
            key: "divider-1",
            disabled: true,
            className: styles.dividerContainer,
            style: {height: "4px"},
            label: <div className={styles.divider}/>
        },
        ...(roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.MenuManager) ? [
            {
                key: RoutingPaths.menuCategoryTable.route,
                icon: <FileTextOutlined/>,
                label: <NavLink to={RoutingPaths.menuCategoryTable.route}>
                    Kategorie menu
                </NavLink>
            },
            {
                key: RoutingPaths.menu.route,
                icon: <ContainerOutlined/>,
                label: <NavLink to={RoutingPaths.menu.route}>
                    Menu PDF
                </NavLink>
            }
        ] : []),
        ...(roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.NewsManager) ? [
            {
                key: RoutingPaths.news.route,
                icon: <CalendarOutlined/>,
                label: <NavLink to={RoutingPaths.news.route}>
                    Aktualności
                </NavLink>
            }
        ] : []),
        ...(roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.BeerManager) ? [
            {
                key: RoutingPaths.beerTable.route,
                icon: <ExperimentOutlined/>,
                label: <NavLink to={RoutingPaths.beerTable.route}>
                    Rodzaje piw
                </NavLink>
            }
        ] : []),
        {
            key: "divider-2",
            disabled: true,
            className: styles.dividerContainer,
            style: {height: "40px"},
            label: <div style={{display: "flex", alignItems: "center"}}>
                <div className={styles.divider}/>
                <span className={styles.text}>Delibeef</span>
                <div className={styles.divider}/>
            </div>
        },
        ...(roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.ProductManager) || roles.includes(ApplicationUserRole.OrderManager) ? [
            {
                key: RoutingPaths.parentCategoryTable.route,
                icon: <BarcodeOutlined/>,
                label: <NavLink to={RoutingPaths.parentCategoryTable.route}>
                    Kategorie produktów
                </NavLink>
            }
        ] : []),
        ...(roles.includes(ApplicationUserRole.Admin) || roles.includes(ApplicationUserRole.OrderManager) ? [
            {
                key: RoutingPaths.orders.route,
                icon: <FileDoneOutlined/>,
                label: <NavLink to={RoutingPaths.orders.route}>
                    Zamówienia
                </NavLink>
            },
            {
                key: RoutingPaths.baskets.route,
                icon: <ShoppingCartOutlined/>,
                label: <NavLink to={RoutingPaths.baskets.route}>
                    Koszyki
                </NavLink>
            },
            {
                key: RoutingPaths.discountCodeTable.route,
                icon: <DollarOutlined/>,
                label: <NavLink to={RoutingPaths.discountCodeTable.route}>
                    Kody rabatowe
                </NavLink>
            }
        ] : []),
        {
            key: "divider-3",
            disabled: true,
            className: styles.dividerContainer,
            style: {height: "4px"},
            label: <div className={styles.divider}/>
        },
        ...(roles.includes(ApplicationUserRole.Admin) ? [
            {
                key: RoutingPaths.userList.route,
                icon: <UserOutlined/>,
                label: <NavLink to={RoutingPaths.userList.route}>
                    Użytkownicy
                </NavLink>
            },
            {
                key: RoutingPaths.deploy.route,
                icon: <CloudUploadOutlined/>,
                label: <NavLink to={RoutingPaths.deploy.route}>
                    Publikacja
                </NavLink>
            }
        ] : []),
        {
            key: "divider-4",
            disabled: true,
            className: styles.dividerContainer,
            style: {height: "4px"},
            label: <div className={styles.divider}/>
        }
    ];

    return <div className={styles.wrapper}>
        <NavLink to={"/"}>
            <div className={styles.logoContainer}>
                <img src={browarkoloLogo} className={styles.browarLogo}/>
                <img src={beeftekaLogo} className={styles.beeftekaLogo}/>
            </div>
        </NavLink>
        <Menu
            theme="dark"
            selectedKeys={[route]}
            mode="inline"
            items={menuItems}
        />
    </div>;
}
